(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["jc-us-stock-delivery"] && !Shopify.designMode) return;
  try {
    (() => {
    const blocks = document.querySelectorAll('[data-jc-us-stock-delivery]');
    if (!blocks.length) return;

    const addBusinessDays = (date, days) => {
      const next = new Date(date);
      next.setHours(12, 0, 0, 0);
      let added = 0;

      while (added < days) {
        next.setDate(next.getDate() + 1);
        const day = next.getDay();
        if (day !== 0 && day !== 6) added += 1;
      }

      return next;
    };

    const formatDate = (date) => new Intl.DateTimeFormat(undefined, {
      month: 'short',
      day: 'numeric'
    }).format(date);

    blocks.forEach((block) => {
      const readyDays = Number(block.dataset.readyDays || 3);
      const usMinDays = Number(block.dataset.usMinDays || 2);
      const usMaxDays = Number(block.dataset.usMaxDays || 7);
      const caMinDays = Number(block.dataset.caMinDays || 3);
      const caMaxDays = Number(block.dataset.caMaxDays || 10);
      const today = new Date();
      today.setHours(12, 0, 0, 0);

      const readyDate = addBusinessDays(today, readyDays);
      const usStart = addBusinessDays(readyDate, usMinDays);
      const usEnd = addBusinessDays(readyDate, usMaxDays);
      const caStart = addBusinessDays(readyDate, caMinDays);
      const caEnd = addBusinessDays(readyDate, caMaxDays);
      const readyTarget = block.querySelector('[data-jc-ready-date]');
      const usTarget = block.querySelector('[data-jc-us-arrival]');
      const caTarget = block.querySelector('[data-jc-ca-arrival]');

      if (readyTarget) readyTarget.textContent = `Ready by ${formatDate(readyDate)}`;
      if (usTarget) usTarget.textContent = `${formatDate(usStart)} - ${formatDate(usEnd)}`;
      if (caTarget) caTarget.textContent = `${formatDate(caStart)} - ${formatDate(caEnd)}`;
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
